// extracted by mini-css-extract-plugin
export default {"toolbar":"toolbar_toolbar__yNqw1"};